/**
* Get Partner Data
* @data example {
 *  name: 'capitalone',
    heading: 'Featured Partner',
    subhead: 'calc_pymt',
    cta: 'Get Pre-Qualified',
* @usage
* `mapPartnerTagToGA(data)`
*/

const mapPartnerTagToGA = _ref => {
  let {
    name,
    heading,
    subhead = '',
    cta = '',
    title = ''
  } = _ref;
  const gaKey = {
    capitalone: {
      partnerName: 'capital-one',
      partnerType: 'finance'
    },
    carchex: {
      partnerName: 'carchex',
      partnerType: 'warranty'
    },
    financeWithUs: {
      partnerName: title,
      partnerType: 'finance'
    },
    rootInsurance: {
      partnerName: 'root-insurance',
      partnerType: 'insurance'
    },
    experian: {
      partnerName: 'experian',
      partnerType: 'credit-report'
    }
  };
  let eventResult = '';
  const parseEventResult = function () {
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    return values.filter(Boolean).map(value => value.replace(/[^a-zA-Z -::_]/g, '').trim().replace(/ /g, '-').toLowerCase()).join('::');
  };

  // experian now do not use heading
  if (gaKey[name]) {
    eventResult = parseEventResult(gaKey[name].partnerType, gaKey[name].partnerName, heading, subhead, cta);
  }
  return eventResult;
};
export default mapPartnerTagToGA;